/**
 * Created by asiulik on 24.08.2018.
 */

define(['jquery'], function ($) {

    var config = {
        header: {
            truncate: {
                desktop: 80,
                mobile: 50
            }
        },
        desc: {
            truncate: {
                desktop: 150,
                mobile: 100
            }
        }
    };

    var TRUNC_REG = RegExp('(?=[' + TRIM_CHARS + '])');
    var TRIM_CHARS = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF';


    function DownloadBox(layoutInstance) {
        this.layoutInstance = layoutInstance;

        $(document).on({
            click: function(){

                window.tracking.trackGTM({
                    'event': 'download',
                    'action': 'downloadAction',
                    'value': $(this).attr('href')
                });

                window.tracking.trackGA([
                    'send',
                    'event',
                    'download',
                    'downloadAction',
                    $(this).attr('href')
                ]);

            }
        }, '.box a')

    }

    DownloadBox.prototype.init = function () {

        var _this = this;

        this.$boxes = $('[data-box-truncate]');
        if (!this.$boxes.length) return;

        this.$boxesHeader = this.$boxes.find('.box__header');
        this.$boxesDesc = this.$boxes.find('.box__desc');

        if (this.$boxesHeader.length) {
            this.$boxesHeader.each(function (index, element) {

                var $element = $(element);
                $element.attr('data-string-desktop', truncateString($element.text(), config.header.truncate.desktop));
                $element.attr('data-string-mobile', truncateString($element.text(), config.header.truncate.mobile));

            });
        }

        if (this.$boxesDesc.length) {
            this.$boxesDesc.each(function (index, element) {

                var $element = $(element);

                $element.attr('data-string-desktop', truncateString($element.text(), config.desc.truncate.desktop));
                $element.attr('data-string-mobile', truncateString($element.text(), config.desc.truncate.mobile));

            });
        }

        this.updateCopyLength();

        this.layoutInstance.on('reload', function(){
            _this.updateCopyLength();
        });

    };

    DownloadBox.prototype.updateCopyLength = function(){

        var _this = this;

        if (this.$boxesHeader.length) {
            this.$boxesHeader.each(function (index, element) {

                var $element = $(element);

                _this.layoutInstance.small || _this.layoutInstance.medium ?
                    $element.text($element.data('stringMobile')) :
                    $element.text($element.data('stringDesktop'))

            });
        }

        if (this.$boxesDesc.length) {
            this.$boxesDesc.each(function (index, element) {

                var $element = $(element);

                _this.layoutInstance.small || _this.layoutInstance.medium ?
                    $element.text($element.data('stringMobile')) :
                    $element.text($element.data('stringDesktop'))

            });
        }

    };

    function truncateString(str, length, from, ellipsis, split) {
        var str1, str2, len1, len2;
        if (str.length <= length) {
            return str.toString();
        }
        ellipsis = isUndefined(ellipsis) ? '...' : ellipsis;
        switch (from) {
            case 'left':
                str2 = split ? truncateOnWord(str, length, true) : str.slice(str.length - length);
                return ellipsis + str2;
            case 'middle':
                len1 = ceil(length / 2);
                len2 = floor(length / 2);
                str1 = split ? truncateOnWord(str, len1) : str.slice(0, len1);
                str2 = split ? truncateOnWord(str, len2, true) : str.slice(str.length - len2);
                return str1 + ellipsis + str2;
            default:
                str1 = split ? truncateOnWord(str, length) : str.slice(0, length);
                return str1 + ellipsis;
        }
    }

    function truncateOnWord(str, limit, fromLeft) {
        if (fromLeft) {
            return reverseString(truncateOnWord(reverseString(str), limit));
        }
        var words = str.split(TRUNC_REG);
        var count = 0;
        return filter(words, function (word) {
            count += word.length;
            return count <= limit;
        }).join('');
    }

    function reverseString(str) {
        return str.split('').reverse().join('');
    }

    function isUndefined(o) {
        return o === undefined;
    }


    return DownloadBox;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/box/box.js